import React from 'react';
import Mascotte from '../Brand/Mascotte';
import './MascotteLoader.css';

/**
 * Loader personnalise utilisant la mascotte Titaton.
 *
 * @param {string}  message  - Texte affiche sous la mascotte (optionnel)
 * @param {'sm'|'md'|'lg'} sizeVariant - Taille du loader (default: 'md')
 * @param {string}  className - Classes CSS additionnelles
 */
const MascotteLoader = ({ message = 'Chargement...', sizeVariant = 'md', className = '' }) => {
  const mascotteSize = { sm: 56, md: 80, lg: 120 }[sizeVariant] || 80;

  const sizeClass = sizeVariant !== 'md' ? `mascotte-loader--${sizeVariant}` : '';

  return (
    <div className={`mascotte-loader ${sizeClass} ${className}`.trim()}>
      <div className="mascotte-loader__scene">
        <Mascotte variant="chargement" size={mascotteSize} />
        <div className="mascotte-loader__stars">
          <span className="mascotte-loader__star" />
          <span className="mascotte-loader__star" />
          <span className="mascotte-loader__star" />
        </div>
      </div>
      {message && <p className="mascotte-loader__text">{message}</p>}
    </div>
  );
};

export default MascotteLoader;
